export const EXPORT_REPORT_DATA_CURRENT_YEAR = 2025;
export const EXPORT_REPORT_DATA_PROJECTED_YEAR = 2030;
export const EXPORT_REPORT_BOUNDARY_GROUP_CODENAME = 'ags-us-zip-codes';
